// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z_tQ","comment":"styles_comment__32fx1"};